(function () {
  function initLandingPage() {
    if (!document.querySelector('.cs2-lp-page-start')) return;
    document.body.classList.add('cs2-landing-template');

    document.querySelectorAll('[data-cs2-offer]').forEach((offer) => {
      if (offer.dataset.initialized === 'true') return;
      offer.dataset.initialized = 'true';

      const variantsEl = offer.querySelector('[data-cs2-variants]');
      const idInput = offer.querySelector('input[name="id"]');
      const priceEls = offer.querySelectorAll('[data-cs2-price]');
      const compareEls = offer.querySelectorAll('[data-cs2-compare]');
      const submit = offer.querySelector('[data-cs2-submit]');
      const mainImage = offer.querySelector('.cs2-lp-offer__main-image');
      const mainImageWrap = offer.querySelector('[data-cs2-main-gallery]');
      const productTitle = offer.querySelector('[data-cs2-product-title]');
      const flavorGroup = offer.querySelector('.cs2-lp-offer__option-group--flavor');
      const skioPicker = offer.querySelector('[data-cs2-skio-picker], skio-plan-picker');
      const externalSubscribeBanner = offer.querySelector('[data-cs2-external-subscribe-banner]');
      const supplementDialog = offer.querySelector('[data-cs2-supplement-dialog]');
      const supplementOpen = offer.querySelector('[data-cs2-supplement-open]');
      const supplementClose = offer.querySelector('[data-cs2-supplement-close]');

      function configureSkioPicker() {
        if (!skioPicker) return;
        const apply = () => {
          const offerStyles = getComputedStyle(offer);
          const gap = offerStyles.getPropertyValue('--cs2-purchase-stack-gap').trim() || '10px';
          skioPicker.style.setProperty('--cs2-purchase-stack-gap', gap);
          skioPicker.style.setProperty('--cs2-skio-banner-bg', offerStyles.getPropertyValue('--cs2-skio-banner-bg').trim() || '#7c5cff');
          skioPicker.style.setProperty('--cs2-skio-banner-text', offerStyles.getPropertyValue('--cs2-skio-banner-text').trim() || '#ffffff');
          skioPicker.style.setProperty('--cs2-skio-banner-size', offerStyles.getPropertyValue('--cs2-skio-banner-size').trim() || '14px');
          skioPicker.style.setProperty('--cs2-skio-banner-size-mobile', offerStyles.getPropertyValue('--cs2-skio-banner-size-mobile').trim() || '12px');
          skioPicker.style.setProperty('--cs2-skio-banner-font-family', offerStyles.getPropertyValue('--cs2-skio-banner-font-family').trim() || 'inherit');
          skioPicker.style.setProperty('--cs2-skio-banner-font-weight', offerStyles.getPropertyValue('--cs2-skio-banner-font-weight').trim() || '800');
          skioPicker.style.setProperty('--cs2-skio-banner-font-style', offerStyles.getPropertyValue('--cs2-skio-banner-font-style').trim() || 'normal');
          const root = skioPicker.shadowRoot;
          if (root && !root.querySelector('style[data-cs2-landing-skio]')) {
            const style = document.createElement('style');
            style.dataset.cs2LandingSkio = 'true';
            style.textContent = `
              .skio-plan-picker{gap:var(--cs2-purchase-stack-gap,10px)!important;margin:0!important;font-family:inherit!important}
              .group-container{overflow:hidden;border-radius:12px!important;box-shadow:none!important;transition:border-color .2s ease,background-color .2s ease}
              .group-container--selected{box-shadow:0 8px 24px rgba(124,92,255,.08)!important}
              .group-label{padding:17px 18px!important}
              .group-topline{gap:10px!important;align-items:center!important}
              .group-title{font-size:1.18em!important;line-height:1.2!important;font-weight:800!important;max-width:none!important}
              .skio-price{font-size:1.08em!important;font-weight:750!important;line-height:1.1!important}
              .skio-price s{font-size:.82em!important;opacity:.55!important}
              .group-container--selected .skio-radio__container{color:var(--cs2-skio-benefit-accent,#7c5cff)!important}
              .savings.bubble{background:var(--cs2-skio-benefit-accent,#7c5cff)!important;border-color:var(--cs2-skio-benefit-accent,#7c5cff)!important;color:#fff!important;border-radius:6px!important;padding:3px 9px!important;font-size:.72em!important;font-weight:800!important;vertical-align:middle!important}
              .group-content.margin-left{margin-left:31px!important}
              .selling-plan-dropdown{margin-top:10px!important;padding:8px 34px 8px 12px!important;background-color:rgba(255,255,255,.72)!important;border:1.5px solid currentColor!important;border-radius:8px!important;font-size:.88em!important;color:inherit!important;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23111111' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m6 9 6 6 6-6'/%3E%3C/svg%3E")!important}
              .group-content-additional{margin-top:14px!important;padding-top:13px!important;border-top:1px solid rgba(17,17,17,.12)!important}
              .group-content-additional ul{list-style:none!important;margin:0!important;padding:0!important;display:grid!important;gap:10px!important}
              .group-content-additional li{position:relative!important;margin:0!important;padding-left:25px!important;color:inherit!important;font-size:var(--cs2-skio-benefit-size,15px)!important;line-height:1.3!important;font-weight:550!important}
              .group-content-additional li::before{content:'✓';position:absolute;left:0;top:-1px;color:var(--cs2-skio-benefit-accent,#7c5cff)!important;font-size:1.15em!important;font-weight:900!important}
              .group-content-additional li:first-child{font-weight:800!important}
              .group-container--last .group-label{padding-top:15px!important;padding-bottom:15px!important}
              @media(max-width:768px){
                .group-label{padding:14px 13px!important}
                .group-title{font-size:1.08em!important}
                .skio-price{font-size:1em!important}
                .group-content.margin-left{margin-left:25px!important}
                .group-content-additional{margin-top:11px!important;padding-top:11px!important}
                .group-content-additional ul{gap:8px!important}
                .group-content-additional li{font-size:calc(var(--cs2-skio-benefit-size,15px) - 1px)!important;padding-left:22px!important}
              }
            `;
            root.appendChild(style);
          }
          updateSkioEnhancements();
        };
        if (customElements.get('skio-plan-picker')) apply();
        else customElements.whenDefined('skio-plan-picker').then(apply).catch(() => {});
      }

      function currentPackSize() {
        const group = offer.querySelector('.cs2-lp-offer__option-group--size');
        const button = group ? group.querySelector('[data-option-value].is-selected') : null;
        const match = String(button?.dataset.optionValue || '').match(/\b(30|60|90)\b/);
        return match ? Number(match[1]) : null;
      }

      function currentDiscountPercent(pack) {
        try {
          if (skioPicker?.selectedSellingPlan && typeof skioPicker.discount === 'function') {
            const value = Number(skioPicker.discount(skioPicker.selectedSellingPlan)?.percent || 0);
            if (value > 0) return Math.round(value);
          }
        } catch (e) {}
        return pack === 90 ? 36 : pack === 60 ? 28 : 15;
      }

      function subscriptionGroup() {
        if (!skioPicker?.shadowRoot) return null;
        const groups = [...skioPicker.shadowRoot.querySelectorAll('.group-container')];
        return groups.find((group) => /subscribe/i.test(group.querySelector('.group-title')?.textContent || ''))
          || groups.find((group) => !/one\s*time/i.test(group.querySelector('.group-title')?.textContent || ''))
          || null;
      }

      function updateExternalSubscribeBanner(pack) {
        if (!externalSubscribeBanner) return;
        const text = pack === 90
          ? offer.dataset.cs2Banner90
          : pack === 60
            ? offer.dataset.cs2Banner60
            : offer.dataset.cs2Banner30;
        const value = String(text || '').trim();
        externalSubscribeBanner.textContent = value;
        externalSubscribeBanner.hidden = !value;
      }

      function positionExternalSubscribeBannerForEditor() {
        if (!externalSubscribeBanner || externalSubscribeBanner.hidden) return;
        const isDesignMode = !!(window.Shopify && window.Shopify.designMode);
        if (!isDesignMode) {
          externalSubscribeBanner.classList.remove('is-editor-positioned');
          externalSubscribeBanner.style.removeProperty('left');
          externalSubscribeBanner.style.removeProperty('top');
          externalSubscribeBanner.style.removeProperty('width');
          return;
        }
        const group = subscriptionGroup();
        const wrapper = externalSubscribeBanner.parentElement;
        if (!group || !wrapper) return;
        const groupRect = group.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const bannerHeight = externalSubscribeBanner.offsetHeight || 44;
        const overlap = 12;
        externalSubscribeBanner.classList.add('is-editor-positioned');
        externalSubscribeBanner.style.left = `${groupRect.left - wrapperRect.left}px`;
        externalSubscribeBanner.style.width = `${groupRect.width}px`;
        externalSubscribeBanner.style.top = `${groupRect.top - wrapperRect.top - bannerHeight + overlap}px`;
      }

      function ensureSubscriptionBenefits(pack) {
        const group = subscriptionGroup();
        if (!group) return;
        const wrap = group.parentElement?.querySelector('.group-content-additional') || group.nextElementSibling?.querySelector?.('.group-content-additional');
        const additional = wrap || skioPicker.shadowRoot.querySelector('.group-content-additional');
        if (!additional) return;
        const discount = currentDiscountPercent(pack);
        additional.innerHTML = `<ul>
          <li>Save ${discount}% on every order</li>
          <li>Free shipping today</li>
          <li>Pause or cancel anytime</li>
          <li>30-day guarantee</li>
          <li>Weekly Tips from Sleep Experts</li>
        </ul>`;
      }

      function frequencyMatches(text, pack) {
        const value = String(text || '').toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
        if (pack === 30) return /monthly/.test(value) || /every\s+(1\s+)?month/.test(value) || /4\s*weeks?/.test(value) || /30\s*days?/.test(value);
        if (pack === 60) return /every\s+2\s+months?/.test(value) || /2\s+months?/.test(value) || /8\s*weeks?/.test(value) || /60\s*days?/.test(value);
        if (pack === 90) return /every\s+3\s+months?/.test(value) || /3\s+months?/.test(value) || /12\s*weeks?/.test(value) || /90\s*days?/.test(value);
        return false;
      }

      let lastFrequencyPack = null;
      function ensureDefaultFrequency(pack) {
        if (!skioPicker?.shadowRoot || !pack || lastFrequencyPack === pack) return;
        const group = subscriptionGroup();
        if (!group) return;
        const content = group.nextElementSibling;
        const dropdown = content?.querySelector?.('.selling-plan-dropdown') || skioPicker.shadowRoot.querySelector('.selling-plan-dropdown');
        if (!dropdown || !dropdown.options?.length) return;
        const target = [...dropdown.options].find((option) => frequencyMatches(option.textContent, pack));
        if (!target) return;
        if (dropdown.value !== target.value) {
          dropdown.value = target.value;
          dropdown.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        }
        lastFrequencyPack = pack;
      }

      function updateSkioEnhancements() {
        if (!skioPicker?.shadowRoot) return;
        const pack = currentPackSize() || 30;
        updateExternalSubscribeBanner(pack);
        ensureSubscriptionBenefits(pack);
        window.requestAnimationFrame(positionExternalSubscribeBannerForEditor);
        ensureDefaultFrequency(pack);
      }

      function syncSkioVariant(variant) {
        if (!skioPicker || !variant) return;
        const applyWhenReady = (attempt = 0) => {
          const sourceVariants = skioPicker.product && Array.isArray(skioPicker.product.variants) ? skioPicker.product.variants : [];
          if (!sourceVariants.length && skioPicker.productHandle && attempt < 50) {
            window.setTimeout(() => applyWhenReady(attempt + 1), 100);
            return;
          }
          const fullVariant = sourceVariants.find((item) => String(item.id) === String(variant.id)) || variant;
          skioPicker.selectedVariant = fullVariant;
          skioPicker.variantChanged = true;
          if (typeof skioPicker.requestUpdate === 'function') skioPicker.requestUpdate();
          window.setTimeout(updateSkioEnhancements, 80);
          window.setTimeout(updateSkioEnhancements, 220);
        };
        if (customElements.get('skio-plan-picker')) applyWhenReady();
        else customElements.whenDefined('skio-plan-picker').then(() => applyWhenReady()).catch(() => {});
      }
      if (!variantsEl || !idInput) return;

      let variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
      let selected = [];
      configureSkioPicker();
      if (skioPicker) {
        customElements.whenDefined('skio-plan-picker').then(() => {
          const attach = (attempt = 0) => {
            if (!skioPicker.shadowRoot) {
              if (attempt < 50) window.setTimeout(() => attach(attempt + 1), 100);
              return;
            }
            if (!skioPicker.__cs2EnhancementObserver) {
              const observer = new MutationObserver(() => window.requestAnimationFrame(updateSkioEnhancements));
              observer.observe(skioPicker.shadowRoot, { childList: true, subtree: true, attributes: true });
              skioPicker.__cs2EnhancementObserver = observer;
            }
            updateSkioEnhancements();
          };
          attach();
        }).catch(() => {});
      }
      if (externalSubscribeBanner && !offer.__cs2BannerResizeBound) {
        window.addEventListener('resize', () => window.requestAnimationFrame(positionExternalSubscribeBannerForEditor), { passive: true });
        offer.__cs2BannerResizeBound = true;
      }

      if (supplementDialog && supplementOpen) {
        supplementOpen.addEventListener('click', () => {
          if (typeof supplementDialog.showModal === 'function') supplementDialog.showModal();
          else supplementDialog.setAttribute('open', '');
        });
        if (supplementClose) supplementClose.addEventListener('click', () => supplementDialog.close());
        supplementDialog.addEventListener('click', (event) => {
          if (event.target === supplementDialog) supplementDialog.close();
        });
      }

      offer.querySelectorAll('[data-option-index]').forEach((group) => {
        const selectedButton = group.querySelector('.is-selected') || group.querySelector('[data-option-value]');
        selected[Number(group.dataset.optionIndex)] = selectedButton ? selectedButton.dataset.optionValue : null;
      });

      function money(cents) {
        const currency = offer.dataset.currency || 'USD';
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
        catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
      }

      function findVariant() {
        return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      }

      function normalized(value) {
        return String(value || '').trim().toLowerCase();
      }

      function setMainImageFromThumb(thumb, scrollThumb) {
        if (!thumb || !mainImage) return;
        const src = thumb.dataset.imageSrc;
        if (src) {
          mainImage.src = src;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
        if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
        offer.querySelectorAll('[data-cs2-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
        if (scrollThumb && thumb.scrollIntoView) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      function visibleGalleryThumbs() {
        return Array.from(offer.querySelectorAll('[data-cs2-thumb]')).filter((item) => !item.hidden);
      }

      function stepGallery(direction) {
        const thumbs = visibleGalleryThumbs();
        if (thumbs.length < 2) return;
        let index = thumbs.findIndex((item) => item.classList.contains('is-active'));
        if (index < 0) index = 0;
        index = (index + direction + thumbs.length) % thumbs.length;
        setMainImageFromThumb(thumbs[index], true);
      }

      if (mainImageWrap) {
        let pointerStartX = null;
        let pointerStartY = null;
        mainImageWrap.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
          try { mainImageWrap.setPointerCapture(event.pointerId); } catch (e) {}
        });
        mainImageWrap.addEventListener('pointerup', (event) => {
          if (pointerStartX == null || pointerStartY == null) return;
          const dx = event.clientX - pointerStartX;
          const dy = event.clientY - pointerStartY;
          pointerStartX = null;
          pointerStartY = null;
          if (Math.abs(dx) >= 44 && Math.abs(dx) > Math.abs(dy) * 1.15) stepGallery(dx < 0 ? 1 : -1);
        });
        mainImageWrap.addEventListener('pointercancel', () => { pointerStartX = null; pointerStartY = null; });
        mainImageWrap.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); stepGallery(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); stepGallery(-1); }
        });
        let lastHorizontalWheel = 0;
        mainImageWrap.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 18) return;
          event.preventDefault();
          const now = Date.now();
          if (now - lastHorizontalWheel < 260) return;
          lastHorizontalWheel = now;
          stepGallery(event.deltaX > 0 ? 1 : -1);
        }, { passive: false });
      }

      function updateFlavorGallery() {
        const selectedFlavor = flavorGroup
          ? selected[Number(flavorGroup.dataset.optionIndex)]
          : '';
        const selectedKey = normalized(selectedFlavor);
        const items = Array.from(offer.querySelectorAll('[data-cs2-gallery-item]'));
        if (!items.length) return;

        const visible = [];
        items.forEach((item) => {
          const itemFlavor = normalized(item.dataset.galleryFlavor);
          const show = !itemFlavor || !selectedKey || itemFlavor === selectedKey;
          item.hidden = !show;
          if (show) visible.push(item);
        });

        offer.querySelectorAll('[data-cs2-flavor-callout]').forEach((item) => {
          const itemFlavor = normalized(item.dataset.galleryFlavor);
          item.hidden = Boolean(itemFlavor && selectedKey && itemFlavor !== selectedKey);
        });

        if (productTitle && selectedFlavor) productTitle.textContent = selectedFlavor;

        offer.querySelectorAll('[data-cs2-supplement-flavor]').forEach((item) => {
          const itemFlavor = normalized(item.dataset.cs2SupplementFlavor);
          item.hidden = Boolean(itemFlavor && selectedKey && itemFlavor !== selectedKey);
        });

        const active = visible.find((item) => item.classList.contains('is-active'));
        if (active) return;

        const hero = visible.find((item) => item.dataset.galleryHero === 'true') || visible[0];
        if (hero) setMainImageFromThumb(hero);
      }

      function updateAvailability() {
        offer.querySelectorAll('[data-option-index]').forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const candidate = selected.slice();
            candidate[index] = button.dataset.optionValue;
            const possible = variants.some((variant) => variant.available && variant.options.every((value, i) => candidate[i] == null || value === candidate[i]));
            button.classList.toggle('is-unavailable', !possible);
            button.disabled = !possible;
          });
        });
      }

      function notifyVariantChanged(variant) {
        const fire = () => document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: variant.id } }));
        fire();
        window.setTimeout(fire, 150);
      }

      function updateVariant() {
        let variant = findVariant();
        if (!variant) {
          variant = variants.find((item) => item.available) || variants[0];
          if (!variant) return;
          selected = variant.options.slice();
          offer.querySelectorAll('[data-option-index]').forEach((group) => {
            const index = Number(group.dataset.optionIndex);
            group.querySelectorAll('[data-option-value]').forEach((button) => {
              button.classList.toggle('is-selected', button.dataset.optionValue === selected[index]);
            });
          });
        }

        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        priceEls.forEach((el) => { el.textContent = money(variant.price); });
        compareEls.forEach((el) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = money(variant.compare_at_price);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        if (submit) submit.disabled = !variant.available;
        updateAvailability();
        updateFlavorGallery();
        syncSkioVariant(variant);
        notifyVariantChanged(variant);
        lastFrequencyPack = null;
        window.setTimeout(updateSkioEnhancements, 100);
        window.setTimeout(updateSkioEnhancements, 300);
      }

      offer.addEventListener('click', (event) => {
        const optionButton = event.target.closest('[data-option-value]');
        if (optionButton && !optionButton.disabled) {
          const group = optionButton.closest('[data-option-index]');
          const index = Number(group.dataset.optionIndex);
          selected[index] = optionButton.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('is-selected', item === optionButton));
          updateVariant();
          return;
        }

        const thumb = event.target.closest('[data-cs2-thumb]');
        if (thumb && mainImage && !thumb.hidden) {
          setMainImageFromThumb(thumb, true);
        }
      });

      updateVariant();
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#cs2-offer"], a[href$="#cs2-offer"]');
      if (!link) return;
      const target = document.querySelector('#cs2-offer .cs2-lp-offer__intro .cs2-lp__eyebrow') || document.querySelector('#cs2-offer');
      if (!target) return;
      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#cs2-offer');
    });

    document.querySelectorAll('[data-cs2-testimonials]').forEach((section) => {
      if (section.dataset.reviewFiltersInitialized === 'true') return;
      section.dataset.reviewFiltersInitialized = 'true';

      const buttons = Array.from(section.querySelectorAll('[data-cs2-review-filter]'));
      const reviewItems = Array.from(section.querySelectorAll('.cs2-lp-testimonials__text-card[data-cs2-review-category]'));
      const textRail = section.querySelector('.cs2-lp-testimonials__text-rail');
      const mediaRail = section.querySelector('.cs2-lp-testimonials__rail');

      function updateRailCentering() {
        if (textRail) {
          const visibleTextCards = Array.from(textRail.querySelectorAll('.cs2-lp-testimonials__text-card')).filter((item) => !item.hidden);
          textRail.classList.toggle('is-centered-fit', visibleTextCards.length > 0 && visibleTextCards.length <= 4);
        }
        if (mediaRail) {
          const mediaCards = Array.from(mediaRail.querySelectorAll('.cs2-lp-testimonials__card')).filter((item) => !item.hidden);
          mediaRail.classList.toggle('is-centered-fit', mediaCards.length > 0 && mediaCards.length <= 4);
        }
      }

      updateRailCentering();
      if (!buttons.length || !reviewItems.length) return;

      function normalizeReviewKey(value) {
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      function applyReviewFilter(key) {
        const normalizedKey = normalizeReviewKey(key) || 'all';
        buttons.forEach((button) => {
          const active = normalizeReviewKey(button.dataset.cs2ReviewFilter) === normalizedKey;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        reviewItems.forEach((item) => {
          const itemKey = normalizeReviewKey(item.dataset.cs2ReviewCategory) || 'all';
          item.hidden = normalizedKey !== 'all' && itemKey !== 'all' && itemKey !== normalizedKey;
        });
        updateRailCentering();
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => applyReviewFilter(button.dataset.cs2ReviewFilter));
      });

      const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
      if (initial) applyReviewFilter(initial.dataset.cs2ReviewFilter);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLandingPage);
  else initLandingPage();
  document.addEventListener('shopify:section:load', initLandingPage);
})();
